const parameter = ({ ...data }) => ({
  method: "GET",
  url: "/parameters",
  data: { ...data },
});

export const parameterApi = {
  parameter,
};
